import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Version from '../../version';
import { useTheme } from '@mui/material/styles';

const StyledContainerWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.main,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 20px 80px 20px',
    position: 'relative',
}));

const StyledContainer = ({ children, showVersion = false, ...props }) => {

    const theme = useTheme();
    return (
        <StyledContainerWrapper {...props}>
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    paddingBottom: showVersion ? '20px' : '0px', // Version이 있을 때 하단 여백 추가
                    backgroundColor: theme.palette.background.main, // 배경색 추가                    
                }}
            >
                {children}
            </Box>
            {showVersion && <Version />}
        </StyledContainerWrapper>
    );
};

export default StyledContainer;
